export default "__VITE_ASSET__B64W8Hal__"